<div class="dashboard-wrapper py-4 px-2 px-md-4 mb-5 mb-md-0">

    <section class="hero-banner p-4 p-md-5 rounded-4 mb-4 text-white position-relative overflow-hidden">
        <div class="position-relative z-2 max-w-xl">
            <div class="badge-secure d-inline-flex align-items-center gap-2 mb-3 px-3 py-2 rounded-pill">
                <i class="bi bi-shield-shaded"></i>Secure Verification Process
            </div>
            <h1 class="display-6 fw-bold mb-3 font-inter-bold">Verify Your Trading Partner</h1>
            <p class="opacity-80 mb-4 lh-base font-inter-light">
                Complete our simple 3-step verification process to verify your buyer or seller. This ensures secure and
                trustworthy transactions for all parties involved.
            </p>
            <button
                class="btn btn-action-start d-inline-flex align-items-center gap-2 text-white px-4 py-2.5 rounded-3 fw-semibold transition-all"
                (click)="startVerificationWorkflow()">
                <i class="bi bi-arrow-right small"></i> Start Verification 
            </button>
        </div>
    </section>

    <!-- <section class="row g-4 mb-5">
        <div class="col-6 col-md-3">
            <div class="stat-card bg-white p-4 rounded-4 border shadow-sm d-flex align-items-top gap-2">
                <div
                    class="stat-icon-wrapper rounded-3 bg-blue-tint d-flex align-items-center justify-content-center text-primary">
                    <i class="bi bi-clock-fill fs-5"></i>
                </div>
                <div>
                    <h3 class="card-data fw-bold mb-0 lh-1">{{ stats.pending }}</h3>
                    <p class="card-text mb-2 mt-1 ">Pending Verifications</p>
                </div>
            </div>
        </div>

        <div class="col-6 col-md-3">
            <div class="stat-card bg-white p-4 rounded-4 border shadow-sm d-flex align-items-top gap-2">
                <div
                    class="stat-icon-wrapper rounded-3 bg-orange-tint d-flex align-items-center justify-content-center text-warning">
                    <i class="bi bi-hourglass-split fs-5"></i>
                </div>
                <div>
                    <h3 class="fw-bold card-data mb-0 lh-1">{{ stats.inReview }}</h3>
                    <p class="card-text mb-2 mt-1 ">In Review</p>
                </div>
            </div>
        </div>

        <div class="col-6 col-md-3">
            <div class="stat-card bg-white px-3 py-4 rounded-4 border shadow-sm d-flex align-items-top gap-2">
                <div
                    class="stat-icon-wrapper rounded-3 bg-green-tint d-flex align-items-center justify-content-center text-success">
                    <i class="bi bi-check-circle-fill fs-5"></i>
                </div>
                <div>
                    <h3 class="fw-bold card-data mb-0 lh-1">{{ stats.completed }}</h3>
                    <p class="card-text mb-2 mt-1 ">Completed this Month</p>
                </div>
            </div>
        </div>

        <div class="col-6 col-md-3">
            <div class="stat-card bg-white p-4 rounded-4 border shadow-sm d-flex align-items-top gap-2">
                <div
                    class="stat-icon-wrapper rounded-3 bg-purple-tint d-flex align-items-center justify-content-center text-purple">
                    <i class="bi bi-currency-dollar fs-5"></i>
                </div>
                <div>
                    <h3 class="fw-bold card-data mb-0 lh-1">${{ stats.spend | number }}</h3>
                    <p class="card-text mb-2 mt-1 ">Verification Spend</p>
                </div>
            </div>
        </div>
    </section> -->

   <section class="bg-white border rounded-4 shadow-sm p-4 mb-5">
    <div class="row g-3 align-items-end justify-content-between">

        <!-- 1. Search Bar (Takes 4/12 columns on LG screens) -->
        <div class="col-12 col-lg-4">
            <label class="form-label text-header fw-semibold tracking-wide mb-1.5">
                Company Name
            </label>
            <div class="position-relative search-input-group">
                <i class="bi bi-search search-icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary"></i>
                <input type="text" class="form-control ps-5 py-2 shadow-none border-light-subtle rounded-3"
                    [ngModel]="pagination$.value.companyName"
                    (input)="onCompanyNameChange($any($event.target).value)"
                    placeholder="Search company...">
            </div>
        </div>

        <!-- 2. Filters Group (Takes 7/12 columns on LG screens - Split 3-ways internally) -->
        <div class="col-12 col-lg-7">
            <div class="row g-2 align-items-end">

                <!-- Country Filter -->
                <div class="col-12 col-sm-4">
                    <label class="form-label text-header fw-semibold tracking-wide mb-1.5">Country</label>
                    <div class="position-relative">
                        <input type="text" class="form-control filter-dropdown filter" placeholder="Filter by Country"
                            [formControl]="countrySearchControl" [matAutocomplete]="countryAuto">

                        <mat-autocomplete #countryAuto="matAutocomplete"
                            (optionSelected)="onCountryChange($event.option.value)">
                            <mat-option value="" class="fw-semibold text-primary">ALL</mat-option>
                            @for(country of filteredCountries$ | async; track country.name){
                            <mat-option [value]="country.name">
                                {{ country.name }}
                            </mat-option>
                            }
                        </mat-autocomplete>
                    </div>
                </div>

                <!-- Sort Key Filter -->
                <div class="col-12 col-sm-4">
                    <label class="form-label text-header fw-semibold tracking-wide mb-1.5">Sort Key</label>
                    <select class="form-control filter-dropdown filter" [ngModel]="pagination$.value.sortKey"
                        (ngModelChange)="onSortKeyChange($event)">
                        <option value="">All</option>
                        <option value="companyName">Company Name</option>
                        <option value="riskRating">Risk Rating</option>
                        <option value="creditRecommendation">Credit Recommendation</option>
                        <option value="requestCount">Request Count</option>
                    </select>
                </div>

                <!-- Sort Order Filter -->
                <div class="col-12 col-sm-4">
                    <label class="form-label text-header fw-semibold tracking-wide mb-1.5">Sort Order</label>
                    <select class="form-control filter-dropdown filter" [ngModel]="pagination$.value.sortOrder"
                        (ngModelChange)="onSortOrderChange($event)">
                        <option value="desc">Latest to Oldest</option>
                        <option value="asc">Oldest to Latest</option>
                    </select>
                </div>

            </div>
        </div>

        <!-- 3. Reset Button Action (Takes 1/12 column on LG screens) -->
        <div class="col-12 col-lg-1 d-flex justify-content-lg-end">
            <button type="button"
                class="btn btn-light border-light-subtle btn-reset text-secondary rounded-3 d-inline-flex align-items-center justify-content-center w-100 py-2"
                (click)="resetSearch()" title="Reset Filters">
                <i class="bi bi-arrow-clockwise fs-5"></i>
            </button>
        </div>

    </div>
</section>
    <section class="bg-white border rounded-4 shadow-sm overflow-hidden mt-4">

        <header class="p-4">
            <h2 class="table-header mb-1 font-inter-bold fw-bold">Canon History</h2>
            <p class="sub-text small mb-0">Manage and track all seller verification requests</p>
        </header>
        @if (canonList$ | async; as state){
        @if(state.loading){
        <div class="overlay">
            <div class="spinner-border"></div>
        </div>
        }
        @else if(state.error){
        <div>
            {{state.error}}
        </div>
        }
        @else if (state.data && state.data.length>0){
        <div class="table-responsive d-none d-md-block">
            <table class="table align-middle custom-dashboard-table mb-0">
                <thead>
                    <tr>
                        <th scope="col" class="text-uppercase x-small text-secondary tracking-wider px-4 py-3">
                            Company
                        </th>
                        <th scope="col" class="text-uppercase x-small text-secondary tracking-wider py-3">
                            Date Submitted
                        </th>
                        <th scope="col" class="text-uppercase x-small text-secondary tracking-wider py-3 text-center">
                            Risk Rating
                        </th>
                        <th scope="col" class="text-uppercase x-small text-secondary tracking-wider py-3 text-center">
                            Credit Recommendation
                        </th>
                        <th scope="col" class="text-uppercase x-small text-secondary tracking-wider py-3">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let record of state.data" class="table-row-hover">
                        <td class="py-3 px-4">
                            <div class="text-dark row-header row-other">{{ record.companyName }}</div>
                            <div class="sub-row x-small mt-0.5">{{ record.country }}</div>
                        </td>

                        <td class="py-3">
                            <div class="text-dark row-header row-other">{{ record.dateCreated | date:'mediumDate'}}
                            </div>
                            <div class="sub-row x-small mt-0.5">{{ record.daysAgo }}</div>
                        </td>

                        <td class="py-3 text-center">
                            <div class="text-dark row-header row-other">{{ record.riskRating }}</div>
                        </td>

                        <td class="py-3 text-center">
                            <div class="text-dark row-header row-other">{{ record.creditRecommendation }}</div>
                        </td>

                        <td class="py-3">
                            <div class="d-flex align-items-center justify-content-start gap-3">
                                <!-- <button
                                    class="btn btn-view-report btn-sm rounded-3 text-primary fw-semibold d-inline-flex align-items-center gap-1">
                                    <i class="bi bi-eye-fill" style="color:#007AFF"></i> View Report
                                </button>

                                <button class="btn p-1 border-0 bg-transparent text-secondary hover-primary rounded-2"
                                    (click)="downloadReport(record.id)">
                                    <i class="bi bi-download"></i>
                                </button> -->
                                <button class="btn p-1 border-0 bg-transparent text-secondary hover-warning rounded-2"
                                    (click)="editCanonForm(record)">
                                    <i class="bi bi-pencil-square"></i>
                                </button>
                                <button class="btn p-1 border-0 bg-transparent text-secondary hover-danger rounded-2"
                                    (click)="deleteRecord(record.id)">
                                    <i class="bi bi-trash-fill"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Mobile view: cards layout -->
        <div class="d-block d-md-none mobile-cards-container">
            <div *ngFor="let record of state.data" class="mobile-card p-3 border-bottom position-relative">

                <!-- Info Grid -->
                <div class="card-info-grid mb-2">
                    <!-- Row 1: Company -->
                    <div class="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                        <span class="text-muted small">Company</span>
                        <span class="fw-semibold text-dark text-end small">{{ record.companyName }}</span>
                    </div>

                    <!-- Row 2: Country -->
                    <div class="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                        <span class="text-muted small">Country</span>
                        <span class="fw-semibold text-dark text-end small">{{ record.country }}</span>
                    </div>

                    <!-- Row 2: Date Submitted -->
                    <div class="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                        <span class="text-muted small">Date Submitted</span>
                        <span class="fw-semibold text-dark text-end small">{{ record.dateCreated | date:'mediumDate'
                            }}</span>
                    </div>

                    <!-- Row 3: Credit Recommendation -->
                    <div class="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                        <span class="text-muted small">Credit Recommendation</span>
                        <span class="fw-semibold text-dark text-end small">{{ record.creditRecommendation || 'Pending'
                            }}</span>
                    </div>

                    <!-- Row 4: Risk Rating -->
                    <div class="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                        <span class="text-muted small">Risk Rating</span>
                        <span class="fw-semibold text-dark text-end small">{{ record.riskRating || 'Pending' }}</span>
                    </div>
                </div>

                <!-- Last Row: Actions Row (Left: View Report | Right: Download, Update, Delete) -->
                <div class="d-flex align-items-end justify-content-end mt-3">
                    <!-- Left Side -->
                    <!-- <button
                        class="btn btn-view-report btn-sm rounded-3 text-primary fw-semibold d-inline-flex align-items-center gap-1">
                        <i class="bi bi-eye-fill" style="color:#007AFF"></i> View Report
                    </button> -->

                    <!-- Right Side -->
                    <div class="d-flex gap-3">
                        <!-- Download Button -->
                        <!-- <button class="btn btn-icon-download p-1 border-0 bg-transparent text-secondary"
                            [class.opacity-25]="record.requestStatus === 'NEW'"
                            [disabled]="record.requestStatus === 'NEW'" (click)="downloadReport(record.id)"
                            title="Download">
                            <i class="bi bi-download"></i>
                        </button> -->

                        <!-- Update / Edit Button -->
                        <button class="btn btn-icon-download p-1 border-0 bg-transparent text-secondary"
                            (click)="editCanonForm(record.id)" title="Update">
                            <i class="bi bi-pencil-square"></i>
                        </button>

                        <!-- Delete Button -->
                        <button class="btn btn-icon-download p-1 border-0 bg-transparent text-danger"
                            (click)="deleteRecord(record.id)" title="Delete">
                            <i class="bi bi-trash3"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <footer class="d-flex flex-column flex-md-row align-items-center justify-content-between p-4 mt-2 ">
            <div class="text-muted small mb-3 mb-md-0">
                Showing {{start}} to {{end}} <span class="fw-semibold text-dark"></span> of <span
                    class="fw-semibold text-dark">{{totalRecord}} records</span>

            </div>
            <nav aria-label="Page navigation dashboard items">
                <ul class="pagination pagination-sm mb-0 gap-2">


                    <li class="page-item" [class.disabled]="currentPage === 0">
                        <button class="page-link rounded-2 border" (click)="onPageChange((+currentPage) - 1)">
                            <i class="bi bi-chevron-left"></i>
                        </button>
                    </li>

                    @for(pageNum of pages; track pageNum){
                    <li class="page-item" [class.active]="currentPage === pageNum">
                        <button class="page-link rounded-2 border" (click)="onPageChange(pageNum)">
                            {{ pageNum + 1 }}
                        </button>
                    </li>
                    }


                    <li class="page-item" [class.disabled]="currentPage === (totalPages - 1)">
                        <button class="page-link rounded-2 border" (click)="onPageChange((+currentPage) + 1)">
                            <i class="bi bi-chevron-right"></i>
                        </button>
                    </li>

                </ul>
            </nav>
        </footer>
        }
        }
    </section>
</div>